module.exports = __webpack_public_path__ + "static/img/bkg_login.7aeb3e0.jpg";